<template>
    <div>
        <b-breadcrumb :items="itemsBread"></b-breadcrumb>
        <div class="p-3">
            <h2 class="mb-5">Add Post Category</h2>
            <ElementCategories category_id="1" elementName="Post"></ElementCategories>
        </div>
    </div>
</template>

<script>
import ElementCategories from "@/components/ElementComponents/ElementCategories";

export default {
    components: {
        ElementCategories,
    },
    methods: {},
    data() {
        return {
            itemsBread: [
                {
                    text: 'Home',
                    to: '/dashboard'
                }, {
                    text: 'Posts',
                    to: '/posts/all'
                }, {
                    text: 'Post Category',
                    href: '#'
                }
            ],
        }
    }
};
</script>
